import { createFileRoute } from '@tanstack/react-router';
import { createAuthenticatedRoute } from '@/common/auth';
import { HomePage } from '@/pages/home';

export const Route = createAuthenticatedRoute('/_app/home')({
	component: HomePage,
});
